/**
 * Push-API-Client: VAPID-Public-Key holen, Subscription anmelden/abmelden.
 */

import { apiFetch } from './api';

export const pushApi = {
  vapidPublicKey: (token: string) =>
    apiFetch<{ publicKey: string }>('/api/push/vapid-public-key', { token }).then(
      (r) => r.publicKey,
    ),

  subscribe: (
    token: string,
    sub: PushSubscriptionJSON,
    deviceName?: string,
  ): Promise<{ id: string; endpoint: string }> =>
    apiFetch<{ subscription: { id: string; endpoint: string } }>('/api/push/subscribe', {
      method: 'POST',
      body: {
        endpoint: sub.endpoint,
        keys: sub.keys,
        deviceName,
      },
      token,
    }).then((r) => r.subscription),

  unsubscribe: (token: string, endpoint: string) =>
    apiFetch<void>('/api/push/subscribe', {
      method: 'DELETE',
      body: { endpoint },
      token,
    }),
};
